<template>
  <div class="user">
    <!--搜索区域-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="应急物资名称">
          <el-input placeholder="请输入应急物资名称" v-model="formInline.search"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
          <el-button size="small" icon="el-icon-download" @click="exportData">
            导出Excel{{ selectedRows.length > 0 ? '(' + selectedRows.length + ')' : '' }}
          </el-button>
          <el-button size="small" icon="el-icon-upload2" @click="importClick">导入</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--操作按钮区域-->
    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加应急物资</el-button>
    </div>

    <!--表格区域-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table 
          size="small" 
          :data="tableData" 
          border 
          style="width: 100%" 
          v-loading="loading"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column prop="name" label="应急物资名称"></el-table-column>
          <el-table-column prop="responsible_department" label="责任部门"></el-table-column>
          <el-table-column prop="contact_phone" label="联系电话"></el-table-column>
          <el-table-column prop="responsible_person" label="责任人"></el-table-column>
          <el-table-column prop="sort" label="排序"></el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <!--组件弹窗-->
    <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :ma_emergency_supplies_id="ma_emergency_supplies_id" v-if="open_edit" @close="closeEdit"></Edit>
    <Import :open_import="open_import" v-if="open_import" @close="closeImport"></Import>
  </div>
</template>

<script>
import AfuncApi from '@/api/afunc.js';
import Add from './part/add.vue';
import Edit from './part/edit.vue';
import Import from './part/import.vue';

export default {
  components: {
    Add,
    Edit,
    Import,
  },
  inject: ['reload'],
  data() {
    return {
      loading: true,
      tableData: [],
      pageSize: 20,
      totalDataNumber: 0,
      curPage: 1,
      formInline: {
        search: ""
      },
      open_add: false,
      open_edit: false,
      ma_emergency_supplies_id: "",
      open_import: false,
      selectedRows: [],
    };
  },
  created() {
    this.getTableList();
  },
  methods: {
    closeImport(e) {
      this.open_import = false;
      if (e.type === "success") {
        this.getTableList(); // 导入成功后刷新列表
      }
    },
    
    importClick() {
      this.open_import = true;
    },
    
    /* 多选框选择变化 */
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    
    /* 导出数据 */
    exportData() {
      try {
        // 构建导出参数
        let exportParams = {
          search: this.formInline.search,
        };

        // 如果有选中的数据，添加选中的ID
        if (this.selectedRows.length > 0) {
          const selectedIds = this.selectedRows.map(row => row.ma_emergency_supplies_id);
          exportParams.selected_ids = selectedIds.join(',');
        }

        // 使用API导出
        const baseUrl = window.location.protocol + '//' + window.location.host;
        let queryString = Object.keys(exportParams)
          .filter(key => exportParams[key] !== '')
          .map(key => `${key}=${encodeURIComponent(exportParams[key])}`)
          .join('&');

        window.location.href = `${baseUrl}/index.php/shop/afunc/handle?model=ma_emergency_supplies&action=export&${queryString}`;
      } catch (error) {
        console.error('导出失败:', error);
        this.$message.error('导出失败');
      }
    },
    
    /*关闭添加*/
    closeAdd(e) {
      this.open_add = false;
      this.getTableList();
    },
    
    closeEdit(e) {
      this.open_edit = false;
      this.getTableList();
    },
    
    getData() {
      this.getTableList();
    },
    
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },
    
    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },
    
    /*获取列表 - 使用通用API*/
    async getTableList() {
      try {
        this.loading = true;
        
        const response = await AfuncApi.call({
          model: 'ma_emergency_supplies',
          action: 'index',
          page: this.curPage,
          list_rows: this.pageSize,
          ...this.formInline
        });
        
        if (response.code === 1 && response.data.list) {
          this.tableData = response.data.list.data || [];
          this.totalDataNumber = response.data.list.total || 0;
        }
      } catch (error) {
        console.error('获取应急物资列表失败:', error);
        this.$message.error('获取数据失败');
      } finally {
        this.loading = false;
      }
    },
    
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },
    
    /*添加应急物资*/
    addClick() {
      this.open_add = true;
    },
    
    /*编辑应急物资*/
    editClick(row) {
      this.ma_emergency_supplies_id = row.ma_emergency_supplies_id;
      this.open_edit = true;
    },
    
    /*删除应急物资 - 使用通用API*/
    async deleteClick(row) {
      try {
        await this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        
        const response = await AfuncApi.call({
          model: 'ma_emergency_supplies',
          action: 'del',
          ma_emergency_supplies_id: row.ma_emergency_supplies_id
        });
        
        if (response.code === 1) {
          this.$message.success('删除成功');
          this.getTableList();
        } else {
          this.$message.error(response.msg || '删除失败');
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败:', error);
          this.$message.error('删除失败');
        }
      }
    }
  }
};
</script>

<style scoped>
.user {
  padding: 20px;
}

.common-seach-wrap {
  background: #f8f9fa;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
}

.common-seach-wrap .demo-form-inline {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.common-level-rail {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
}

.product-content {
  .table-wrap {
    margin-bottom: 20px;
  }
  
  .pagination {
    display: flex;
    justify-content: center;
    padding: 20px 0;
  }
}

.el-table {
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.el-table::v-deep .el-table__header-wrapper {
  background: #f8f9fa;
}

.el-table::v-deep .el-table__header-wrapper th {
  background: #f8f9fa;
  font-weight: bold;
  color: #333;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/ma_emergency_supplies/index/index.vue